import styled, { keyframes } from 'styled-components';

const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
`;

const ErrorPageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.5rem;
  background: var(--color-surface-bg);
`;

const ErrorCard = styled.div`
  width: 100%;
  max-width: 420px;
  background: var(--color-surface-card);
  border: 1px solid var(--color-surface-border);
  border-radius: var(--radius-card);
  box-shadow: 0 8px 24px var(--color-surface-shadow);
  padding: 2.75rem 2.25rem;
  text-align: center;
  animation: ${fadeInUp} 0.5s ease-out;
`;

const IconCircle = styled.div`
  width: 64px;
  height: 64px;
  margin: 0 auto 1.5rem;
  border-radius: 50%;
  background: rgba(220, 38, 38, 0.1);
  color: var(--color-error);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Title = styled.h2`
  margin: 0 0 0.75rem;
  color: var(--color-text-title);
  font-size: 1.4rem;
  font-weight: 700;
`;

const Description = styled.p`
  margin: 0 0 2rem;
  color: var(--color-text-body);
  font-size: 0.92rem;
  line-height: 1.55;
`;

const ActionButton = styled.button`
  min-width: 160px;
  min-height: 46px;
  padding: 0.75rem 1.75rem;
  background: var(--color-accent);
  border: none;
  color: #ffffff;
  border-radius: var(--radius-control);
  font-family: inherit;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    background: var(--color-accent-hover);
  }

  &:active {
    box-shadow: 0 0 0 3px var(--color-accent-soft);
  }
`;

const ErrorPageStyled = {
  ErrorPageWrapper,
  ErrorCard,
  IconCircle,
  Title,
  Description,
  ActionButton,
};

export default ErrorPageStyled;
